import { type FC, type ReactNode } from 'react';
import { Web3ReactProvider } from '@web3-react/core';
import { providers } from 'ethers';

import { DibsWeb3ConnectionProvider } from './useWeb3Connection.tsx';

type Provider = providers.ExternalProvider | providers.JsonRpcFetchFunc;

function getLibrary(provider: Provider): providers.Web3Provider {
    const library = new providers.Web3Provider(provider);
    library.pollingInterval = 12000;
    return library;
}

const DibsWeb3ReactProvider: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <Web3ReactProvider getLibrary={getLibrary}>
            <DibsWeb3ConnectionProvider>{children}</DibsWeb3ConnectionProvider>
        </Web3ReactProvider>
    );
};

export { DibsWeb3ReactProvider };
